module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-Medium TH.5725b226.woff2";